import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  styled,
} from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { Trans } from 'react-i18next';

import { Form, Checkbox, Typography } from '@app-velocity/ui';
import { MessageBus } from '@app-velocity/message-bus';

import { UserRegisterDto } from '../../../dto/UserRegisterDto';
import { REGISTRATION_PAGE_TEST_IDS } from '../RegisterForm';

const messageBus = new MessageBus('users');

const StyledAgreementLink = styled('a')({
  textDecoration: 'underline',
  cursor: 'pointer',
  lineHeight: 1.1,
  color: 'var(--text-link-primary-color)',
  '&:link,&:visited,&:hover,&:active': {
    color: 'var(--text-link-primary-color)',
  },
});

export const Agreement = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<UserRegisterDto>();

  const openAgreement = (type: 'eula' | 'privacy-policy') => {
    messageBus.publish(`modal:${type}:open`);
  };

  return (
    <Form.FieldContainer>
      <FormControl error={!!errors.acceptedAgreements}>
        <Typography>
          <FormControlLabel
            label={
              <Typography>
                <Trans
                  i18nKey="users:auth.agreement"
                  components={{
                    eula: (
                      <StyledAgreementLink
                        onClick={() => openAgreement('eula')}
                      />
                    ),
                    privacy: (
                      <StyledAgreementLink
                        onClick={() => openAgreement('privacy-policy')}
                      />
                    ),
                  }}
                />
              </Typography>
            }
            control={
              <Checkbox
                {...register('acceptedAgreements')}
                //   error={!!formErrors.finalQuestion}
                inputProps={{
                  // @ts-expect-error https://github.com/mui/material-ui/issues/20160
                  'data-testid':
                    REGISTRATION_PAGE_TEST_IDS.EULA_PRIVACY_AGREEMENT,
                }}
              />
            }
          />
        </Typography>
        {errors.acceptedAgreements ? (
          <FormHelperText>{errors.acceptedAgreements?.message}</FormHelperText>
        ) : null}
      </FormControl>
    </Form.FieldContainer>
  );
};
